module.exports = __webpack_public_path__ + "55bb8a3a25bc4381b74f5ba87af886d9.png";